import type { SplitSlotDef } from '../shared/split-slot/types';

type HasSplitPart = { splitPart?: string | null };

export type SlotMatch<T> = { match: T; index: number } | null;

/**
 * Maps cutsheetInformation entries to split slot positions by `splitPart`.
 * Consumes matches in order to handle duplicate splitParts (e.g. two halves).
 */
export function matchSlotsToContacts<T extends HasSplitPart>(
  slotDefs: SplitSlotDef[],
  cutsheetInformation: (T | null | undefined)[],
): SlotMatch<T>[] {
  const infos = [...cutsheetInformation].filter(Boolean) as T[];
  const used = new Set<number>();

  return slotDefs.map((slot) => {
    const idx = infos.findIndex(
      (ci, i) => !used.has(i) && ci?.splitPart === slot.part,
    );
    if (idx !== -1) {
      used.add(idx);
      return { match: infos[idx], index: idx };
    }
    return null;
  });
}
